export const sublicenseTilesText = {
    classG : "Full Privileges",
    classG1 : "The First Step",
    classG2 : "Intermediate Stage",
    classM1: "The First Step",
    classM2: "Intermediate Stage",
    classM: "Full Privileges",
    classMwithL: "Level M1, M2, M with condition L license",
    classMWithCondtion1: "Level M1, M2, M with Condition 1 license",
}